import {
  So5LeaderboardType,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { CommunityBlock } from '@sorare/core/src/components/landing/CommunityBlock';

type Props = {
  leaderboards: So5LeaderboardType[];
};
export const Community = ({ leaderboards }: Props) => {
  return (
    <CommunityBlock
      leaderboards={leaderboards.map(leaderboardType => ({
        sport: Sport.FOOTBALL,
        leaderboardType,
      }))}
    />
  );
};
